import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'right-panel',
  imports: [],
  templateUrl: './right-panel.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './right-panel.component.scss',
})
export class RightPanelComponent {}
